import { IRequestScheduled, IRequestScheduledRaw } from '../types'

export class RequestScheduleAttendancePixMapper {
  static toPersistence(data: IRequestScheduled): IRequestScheduledRaw {
    return {
      atendimento: {
        idTriagem: data.attendance.screeningId,
        dataHoraAgendamento: data.attendance.dateAttendance,
        idProfissional: data.attendance.professionalId,
        cartaoConvenio: {
          id: data?.attendance?.healthInsuranceCard.id ?? null,
        },
        aps: data.attendance.aps,
        pagamento: {
          idTransacao: data.attendance.payment.transactionId,
          metodo: data.attendance.payment.method,
          sintomas: data.attendance.payment.symptoms,
          sintomasEvidentes:
            data.attendance.payment.evidentSymptoms ||
            data.attendance.payment.symptoms,
          tipoProfissional: data.attendance.payment.professionalType,
        },
      },
      contato: {
        email: data.contact.email,
        celular: data.contact.cellphone,
      },
    }
  }
}
